import styled from "styled-components";

export const LastQueriesEmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  column-gap: var(--allie-spacing-xl);
`;

export const EmptyStateIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 48px;
  row-gap: var(--allie-spacing-xl);
  border-radius: var(--allie-radius-full);
  background-color: var(--allie-color-neutral-10);
`;
